import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

/**
 * Вывод данных с поясняющей меткой
 */

@Component({
    selector: 'app-labeled-data',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <ng-content></ng-content>
        <small style="margin-top: 3px; display: block" class="info">
            <span [innerHTML]="label"></span>&nbsp;<lib-icon type="help" *ngIf="info"
            style="margin-bottom: -2px"
            [size]="12"
            appPopoverMessage
            [appPopoverMessage]="info"></lib-icon>
        </small>
    `,
    styles: [`
        :host {
            display: block;
            margin-bottom: 16px;
            max-width: 100%;
        }
    `]
})

export class LabeledDataComponent {
    /**
     * Наименование метки
     */
    @Input() label = '&nbsp;';

    /**
     * Дополнительная информация, выводящаяся как popover
     */
    @Input() info: string;
}
